import { Component, input } from '@angular/core';
import { ImageCoverComponent } from 'app/shared/image-cover/image-cover.component';

@Component({
  selector: 'app-image-preview',
  standalone: true,
  imports: [ImageCoverComponent],
  templateUrl: './image-preview.component.html',
  styleUrl: './image-preview.component.scss',
  host: {
    class: 'overflow-hidden',
  },
})
export class ImagePreviewComponent {
  url = input.required<string | null>();
}
